<template>
  <div>
    <WebsiteHeader></WebsiteHeader>
    <div class="mt-16">
      <v-row>
        <v-col :cols="isMobile ? 12 : 6">
          <div>
            <v-row class="mx-4 mt-4 mb-8">
              <v-col :cols="isMobile ? 12 : 6">
                <div>
                  <v-expansion-panels :class="isMobile ? 'mt-4' : 'mt-n2'" dark>
                    <v-expansion-panel
                      :style="{
                        'background-color': getThemeColor,
                      }"
                      :key="1"
                    >
                      <v-expansion-panel-header>
                        <h5
                          :style="{
                            color: getSecondaryColor,
                          }"
                        >
                          1. Company Information
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <CompanyForm
                          @company-updated="updateCompanyInfo"
                        ></CompanyForm>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <div class="mt-4">
                  <v-expansion-panels :class="isMobile ? 'mt-4' : 'mt-4'" dark>
                    <v-expansion-panel
                      :key="2"
                      :style="{
                        'background-color': '#607D8B',
                      }"
                    >
                      <v-expansion-panel-header>
                        <h5
                          :style="{
                            color: getSecondaryColor,
                          }"
                        >
                          2. Client Information
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <ClientForm
                          @client-updated="getSelectedClient"
                        ></ClientForm>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <div class="mt-4">
                  <vAlertHeader
                    title="3. Add Services & Products"
                    color="teal"
                  ></vAlertHeader>

                  <v-row class="mx-auto">
                    <v-col :cols="4"
                      ><v-card
                        elevation="12"
                        class="pl-2"
                        :style="{
                          backgroundColor: 'green',
                          borderRadius: '5px',
                          color: 'white',
                        }"
                        @click="showServiceForm()"
                      >
                        <center>
                          Click To Add <v-icon dark>mdi-cash</v-icon>Service
                        </center>
                      </v-card></v-col
                    >
                    <v-col :cols="4"
                      ><v-card
                        elevation="24"
                        class="pl-2"
                        :style="{
                          backgroundColor: 'green',
                          borderRadius: '5px',
                          color: 'white',
                        }"
                        @click="showProductForm()"
                      >
                        <center>
                          Click To Add <v-icon dark>mdi-cart</v-icon>Product
                        </center>
                      </v-card></v-col
                    >
                    <v-col :cols="4"
                      ><v-card
                        elevation="12"
                        :style="{
                          backgroundColor: 'green',
                          borderRadius: '5px',
                          color: 'white',
                        }"
                        @click="showTransportForm()"
                      >
                        <center class="mx-auto">
                          Click To Add
                          <v-icon dark>mdi-airplane-takeoff</v-icon>Transport
                        </center>
                      </v-card></v-col
                    >
                  </v-row>

                  <div v-if="!isMobile">
                    <ServiceForm
                      v-if="showServiceFormContext"
                      @service-updated="addItemToSelection"
                    ></ServiceForm>
                    <ProductForm
                      v-else-if="showProductFormContext"
                      @product-updated="addItemToSelection"
                    ></ProductForm>
                    <TransportForm
                      v-else-if="showTransportFormContext"
                      @transport-updated="addItemToSelection"
                    ></TransportForm>
                  </div>
                  <!-- <v-expansion-panels class="mt-4" dark>
                    <v-expansion-panel
                      :key="3"
                      :style="{
                        'background-color': 'teal',
                      }"
                    >
                      <v-expansion-panel-header>
                        <h5
                          :style="{
                            color: getSecondaryColor,
                          }"
                        >
                          3. Add Services & Products
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <ServiceForm
                          @service-updated="addItemToSelection"
                        ></ServiceForm>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels> -->
                </div>

                <!-- <div class="mt-4">
                  <v-expansion-panels class="mt-4" dark>
                    <v-expansion-panel
                      :key="1"
                      :style="{ 'background-color': '#827717' }"
                    >
                      <v-expansion-panel-header>
                        <h5 :style="{ color: getSecondaryColor }">
                          4. Add Product
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <ProductForm
                          @product-updated="addItemToSelection"
                        ></ProductForm>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div> -->

                <!-- <div class="mt-4">
                  <v-expansion-panels class="mt-4" dark>
                    <v-expansion-panel
                      :key="5"
                      :style="{ 'background-color': 'brown' }"
                    >
                      <v-expansion-panel-header>
                        <h5 :style="{ color: getSecondaryColor }">
                          5. Add Transport
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <TransportForm
                          @transport-updated="addItemToSelection"
                        ></TransportForm>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div> -->
              </v-col>
              <v-col :cols="isMobile ? 12 : 6">
                <SelectedItem
                  v-if="selectedInvoice.items.length > 0"
                  :items="selectedInvoice.items"
                  @update-line-total="updateLineTotal"
                  @remove-item="removeItem"
                ></SelectedItem>

                <v-alert
                  v-if="isMobile && selectedClient && selectedInvoice"
                  dismissible
                  color="cyan"
                  border="left"
                  elevation="2"
                  colored-border
                  icon="mdi-check"
                >
                  <p class="mb-n3">{{ selectedClient.name }}</p>
                  <small>[{{ selectedClient.institution }}]</small><br />
                  <strong
                    >Total {{ docType }}
                    {{
                      getCurrency +
                      formatMoney(selectedInvoice.totalInvoiceAmount)
                    }}</strong
                  >
                </v-alert>
                <!-- <v-btn
                  dark
                  color="teal"
                  v-if="selectedClient"
                  block
                  @click="saveInvoiceData()"
                  ><v-icon>mdi-upload</v-icon> Save {{ docType }} To
                  Database<v-icon>mdi-database</v-icon>
                </v-btn> -->
                <div>
                  <v-btn
                    class="mt-n2"
                    x-large
                    dark
                    block
                    color="#1B5E20"
                    v-if="selectedClient"
                    @click="DownloadInvoicePdf()"
                    ><v-icon>mdi-download</v-icon>4. Download {{ docType }}
                    <v-icon>mdi-file-pdf</v-icon>
                  </v-btn>
                </div>

                <div class="mt-4">
                  <v-expansion-panels class="mt-4" dark>
                    <v-expansion-panel
                      :key="7"
                      :style="{
                        'background-color': getThemeColor,
                      }"
                    >
                      <v-expansion-panel-header>
                        <h5
                          :style="{
                            color: getSecondaryColor,
                          }"
                        >
                          5. Date, Discounts & Comments
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <DatesCommentsAndDiscounts
                          v-if="selectedClient"
                          @date-selected="getSelectedDate"
                          @get-discount-amount="getDiscountAmount"
                          @get-comment="getComment"
                        >
                        </DatesCommentsAndDiscounts>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>

                <div class="mt-4">
                  <v-expansion-panels class="mt-4" dark>
                    <v-expansion-panel
                      :key="8"
                      :style="{
                        'background-color': '#424242',
                      }"
                    >
                      <v-expansion-panel-header>
                        <h5
                          :style="{
                            color: getSecondaryColor,
                          }"
                        >
                          6. Other Settings
                        </h5>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <OtherSettings
                          v-if="selectedClient"
                          @template-selected="getSelectedTemplate"
                          @docType-selected="getSelectedDocType"
                          @get-comment="getComment"
                          @logo-loaded="getLogoBase64Url"
                        >
                        </OtherSettings>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col v-if="!isMobile" :cols="isMobile ? 12 : 6" class="mt-4">
          <iframe
            :src="pdf"
            width="100%"
            height="1200"
            type="application/pdf"
          ></iframe>
        </v-col>
      </v-row>
    </div>

    <GlobalDialogSlot
      v-if="isMobile"
      :title="dialogTitle"
      :dialog="dialog"
      @close-dialog="closeDialog()"
    >
      <ServiceForm
        v-if="showServiceFormDialog"
        @service-updated="addItemToSelection"
      ></ServiceForm>
      <ProductForm
        v-else-if="showProductFormDialog"
        @product-updated="addItemToSelection"
      ></ProductForm>
      <TransportForm
        v-else-if="showTransportFormDialog"
        @transport-updated="addItemToSelection"
      ></TransportForm>
    </GlobalDialogSlot>

    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import invoicesAndQuotesJs from "@/plugins/invoicesAndQuotes";
import pdfMakeParts from "@/plugins/pdfMakeParts";
// import SelectionsPane from "./SelectionsPane.vue";
import SelectedItem from "./SelectedItem.vue";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import GlobalDialogSlot from "../myLibrary/GlobalDialogSlot.vue";
import vAlertHeader from "../Legos/vAlertHeader.vue";
import CompanyForm from "./FrontPageInvoicesAndQuotes/CompanyForm.vue";
import ClientForm from "./FrontPageInvoicesAndQuotes/ClientForm.vue";
import ServiceForm from "./FrontPageInvoicesAndQuotes/ServiceForm.vue";
import ProductForm from "./FrontPageInvoicesAndQuotes/ProductForm.vue";
import TransportForm from "./FrontPageInvoicesAndQuotes/TransportForm.vue";
import DatesCommentsAndDiscounts from "./FrontPageInvoicesAndQuotes/DatesCommentsAndDiscounts.vue";
import OtherSettings from "./FrontPageInvoicesAndQuotes/OtherSettings.vue";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "Invoice",
  props: {
    selectedInvoiceProp: {
      default: null,
    },
    docType: {
      default: "Invoice",
    },
  },
  components: {
    // SelectionsPane,
    SelectedItem,
    GlobalDialogSlot,
    vAlertHeader,
    CompanyForm,
    ClientForm,
    ServiceForm,
    ProductForm,
    TransportForm,
    DatesCommentsAndDiscounts,
    WebsiteHeader,
    WebsiteFooter,
    OtherSettings,
  },
  watch: {
    async docType(newDocType) {
      await this.initialiseInvoice(null, newDocType);
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    if (this.selectedInvoiceProp) {
      await this.initialiseInvoice(this.selectedInvoiceProp, this.docType);
    } else if (this.$route.params.selectedInvoice) {
      await this.initialiseInvoice(
        this.$route.params.selectedInvoice,
        this.$route.params.docType
      );
    } else {
      await this.initialiseInvoice(null, this.docType);
    }

    await this.generatePDF(this, pdfMakeParts.getPdfStyles());
  },
  data() {
    return {
      logoBase64Url: null,
      pdf: null,
      dialog: false,
      dialogTitle: null,
      invoiceDate: new Date().toISOString().substring(0, 10),
      selectedClient: {
        name: "Staff Name",
        client_reference: "0210921923",
        phone: null,
        institution: "General Company",
        position: "Staff",
        email: "abc@gmail.com",
        address: "123 Street",
        city: "Durban",
        postal_code: "4001",
      },
      stamp64: null,
      selectedTemplate: "colored",
      company: {
        invoiceNUmber: "25-001",
        name: "Company Name",
        primary_phone: "012 345 6789",
        email: "company@gmail.com",
        primary_address: "123 Ken Street",
        city: "Durban",
        postal_code: "4001",
        bank: "First National Bank",
        account_number: "63248300231",
        account_type: "Cheque",
        vat_number: "4230240000",
        reg_number: "2002/032291/01",
        emis: "121-free-invoices-and-quotes",
        tax_rate: 0,
      },
      selectedInvoice: {
        invoiceNumber: "25-001",
        items: [],
        totalServices: 0,
        subTotal: 0,
        taxPercent: 0,
        totalTax: 0,
        totalProducts: 0,
        totalTransports: 0,
        totalInvoiceAmount: 0,
        discount: 0,
        description: "",
        taxID: 0,
      },
      showServiceFormContext: true,
      showServiceFormDialog: false,
      showProductFormContext: false,
      showProductFormDialog: false,
      showTransportFormContext: false,
      showTransportFormDialog: false,
    };
  },
  methods: {
    showServiceForm() {
      this.closeDialog();
      if (this.isMobile) {
        this.showServiceFormDialog = true;
        this.dialogTitle = "Add Service To " + this.docType;
        this.dialog = true;
      } else {
        this.showServiceFormContext = true;
      }
    },
    showProductForm() {
      this.closeDialog();
      if (this.isMobile) {
        this.showProductFormDialog = true;
        this.dialogTitle = "Add Product To " + this.docType;
        this.dialog = true;
      } else {
        this.showProductFormContext = true;
      }
    },
    showTransportForm() {
      this.closeDialog();
      if (this.isMobile) {
        this.showTransportFormDialog = true;
        this.dialogTitle = "Add Transport To " + this.docType;
        this.dialog = true;
      } else {
        this.showTransportFormContext = true;
      }
    },
    async initialiseInvoice(invoice, docType) {
      this.$store.commit("setLoader", true);
      let invoiceData = null;
      if (invoice && invoice.invoice_number) {
        invoiceData = await invoicesAndQuotesJs.getInvoiceData(
          invoice.invoice_number,
          docType
        );
        await this.setInvoiceData(invoiceData);
      } else {
        // invoiceData = await invoicesAndQuotesJs.getInvoiceData(null, docType);
        const invoiceDataAndIp = await invoicesAndQuotesJs.getInvoiceData(
          null,
          docType
        );

        if (invoiceDataAndIp && invoiceDataAndIp.ip_data) {
          this.$store.commit(
            "setCurrency",
            invoiceDataAndIp.ip_data.currencyCode
          );
          localStorage.setItem(
            "currency",
            invoiceDataAndIp.ip_data.currencyCode
          );
        }
        if (this.company && this.company.invoiceNumber) {
          invoiceData = { invoice_number: this.company.invoiceNumber };
          await this.setInvoiceData(invoiceData);
        }
      }
      this.$store.commit("setLoader", false);
    },
    async getLogoBase64Url(logoBase64Url) {
      this.logoBase64Url = logoBase64Url;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async updateCompanyInfo(company) {
      this.company = company;
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async setInvoiceData(invoiceData) {
      if (invoiceData.invoice && invoiceData.invoice.client) {
        const invoice = invoiceData.invoice;
        this.selectedInvoice.invoiceNumber = invoice.invoice_number;
        this.invoiceDate = invoice.invoice_date;
        this.selectedClient = invoice.client;
        this.selectedInvoice.items = invoice.items;
        this.selectedInvoice.description = invoice.description;
        this.selectedInvoice.discount = invoice.calculation.discount;
      } else {
        this.selectedInvoice.invoiceNumber = invoiceData.invoice_number;
      }
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    async getSelectedClient(client) {
      this.selectedClient = client;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getSelectedDate(selectedDate) {
      this.invoiceDate = selectedDate;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getSelectedTemplate(selectedTemplate) {
      this.selectedTemplate = selectedTemplate;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getSelectedDocType(docType) {
      this.docType = docType;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getDiscountAmount(discountAmount) {
      this.selectedInvoice["discount"] = Number(discountAmount);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async getComment(comment) {
      this.selectedInvoice.description = comment;
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async addItemToSelection(item) {
      item.quantity = item.quantity ? item.quantity : 1;
      item.lineTotal = (Number(item.price) * Number(item.quantity)).toFixed(2);
      if (this.isMobile) {
        this.$toast.success("Item Added Successfully!", { duration: 3000 });
        this.closeDialog();
      }
      this.selectedInvoice.items.push(item);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async updateLineTotal(item) {
      item.lineTotal = (Number(item.price) * Number(item.quantity)).toFixed(2);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    async removeItem(arr) {
      const items = arr[0];
      const ind = arr[1];
      items.splice(ind, 1);
      this.reCalculateTotals();
      await this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    reCalculateTotals() {
      this.selectedInvoice = invoicesAndQuotesJs.reCalculateTotals(
        this.selectedInvoice,
        this.company.tax_rate
      );
    },
    async generatePDF(vue, style) {
      const docDefinition = {
        content: await this.getContent(),
        styles: style,
      };

      const doc = pdfMake.createPdf(docDefinition);
      doc.getDataUrl((dataUrl) => {
        this.pdf = dataUrl;
      });
    },
    async DownloadInvoicePdf() {
      const docDefinition = {
        content: await this.getContent(),
        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#2196F3",
          },
          subHeader: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 20],
            color: "#2196F3",
          },
          addressSection: {
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#000",
          },
          fillColumns: {
            margin: [0, 10, 0, 20],
          },
          tableStyle: {
            margin: [0, 10, 0, 20],
          },
          email: {
            fontSize: 12,
            color: "#2196F3",
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 20],
          },
        },
      };

      pdfMake
        .createPdf(docDefinition)
        .download(
          this.getUserCompany.name +
            " " +
            this.docType +
            " " +
            this.selectedInvoice.invoiceNumber
        );
    },
    async getContent() {
      return await pdfMakeParts.getContentFrontPage(
        this.company,
        this.docType.toUpperCase(),
        this.selectedInvoice,
        this.selectedClient,
        this.invoiceDate,
        this.logoBase64Url
      );
    },
    async saveInvoiceData() {
      this.$store.commit("setLoader", true);

      const response = await invoicesAndQuotesJs.saveInvoiceData(
        this.docType,
        this.selectedClient,
        this.selectedInvoice,
        this.invoiceDate
      );

      this.$store.commit("setLoader", false);
      this.$toast.success("Invoice Data Successfully Saved", {
        duration: 3000,
      });
    },
    closeDialog() {
      this.dialog = false;
      this.dialogTitle = "Title";
      this.showServiceFormContext = false;
      this.showServiceFormDialog = false;
      this.showProductFormContext = false;
      this.showProductFormDialog = false;
      this.showTransportFormContext = false;
      this.showTransportFormDialog = false;
    },
  },
};
</script>

<style></style>
